theme.TestimonialSlider = (function () {
  function Slider(e) {
    let slideshow = e.querySelector(".testimonial_slider"),
      paginationSelector = e.querySelector(".swiper-pagination"),
      navselectorPrev = e.querySelector(".swiper-button-prev"),
      navselectorNext = e.querySelector(".swiper-button-next"),
      extraLargeDesktopShow = parseInt(e.dataset.showExtraLarge),
      mobileShow = parseInt(e.dataset.showMobile),
      tabletShow = parseInt(e.dataset.showTablet),
      largeDesktopShow = parseInt(e.dataset.showLarge),
      autoplaySelctor = e.dataset.sliderAutoplay,
      autoplayInit = false,
      autoPlayDelay = parseInt(e.dataset.sliderDelay),
      loopSelector = e.dataset.sliderLoop,
      loopInit = false,
      slidePagination = e.dataset.pagination,
      paginatinInit = "bullets",
      swiperItem = e.querySelectorAll(".swiper-slide"),
      blockSize = null,
      authImage = e.dataset.authorPosition,
      centerSlide = false;

    if (autoplaySelctor == "true") {
      autoplayInit = { delay: autoPlayDelay };
    }
    if (loopSelector == "true") {
      loopInit = true;
    }
    if (slidePagination == "counter") {
      paginatinInit = "fraction";
    } else {
      paginatinInit = "bullets";
    }
    if (authImage == "center") {
      blockSize = parseInt(e.dataset.blockSize);
      centerSlide = true;
    }

    var swiper2 = new Swiper(".testimonial_thumb", {
      slidesPerView: blockSize,
      spaceBetween: 10,
      freeMode: true,
      watchSlidesProgress: true,
      centeredSlides: true,
      loop: true,
    });
    var swiper = new Swiper(slideshow, {
      loop: true,
      spaceBetween: 30,
      pagination: {
        el: paginationSelector,
        clickable: true,
        type: paginatinInit,
      },
      autoplay: autoplayInit,
      autoHeight: true,
      centeredSlides: centerSlide,
      loopedSlides: blockSize,
      navigation: {
        nextEl: navselectorNext,
        prevEl: navselectorPrev,
      },
      breakpoints: {
        640: {
          slidesPerView: mobileShow,
        },
        750: {
          slidesPerView: extraLargeDesktopShow,
          autoHeight: false,
        },
        992: {
          slidesPerView: extraLargeDesktopShow,
          autoHeight: false,
        },
        1200: {
          slidesPerView: extraLargeDesktopShow,
          autoHeight: false,
        },
      },
    });

    // Desktop: auto-scroll when in viewport
    if (window.matchMedia("(min-width: 750px)").matches) {
      var autoScrollDelay = 5000;
      var autoScrollRunning = false;

      function startAutoScroll() {
        if (autoScrollRunning) return;
        autoScrollRunning = true;
        swiper.params.autoplay = {
          delay: autoScrollDelay,
          disableOnInteraction: false,
        };
        swiper.params.speed = 800;
        swiper.autoplay.start();
      }

      function stopAutoScroll() {
        autoScrollRunning = false;
        swiper.autoplay.stop();
      }

      if ("IntersectionObserver" in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                startAutoScroll();
              } else {
                stopAutoScroll();
              }
            });
          },
          { threshold: 0.3 }
        );
        observer.observe(e);
      }
    }

    if (authImage === "center") {
      swiper.controller.control = swiper2;
      swiper2.controller.control = swiper;
    }

    if (Shopify.designMode) {
      function onBlockSelect(event) {
        const blockId = event.detail.blockId;
        swiperItem.forEach((item) => {
          const ItemBlockId = item.getAttribute("data-block-id");
          if (blockId === ItemBlockId) {
            const swiperItemIndex = item.getAttribute("data-slide-index");
            swiper.slideTo(swiperItemIndex);
            sessionStorage.setItem("selectedSlideIndex", swiperItemIndex);
          }
        });
      }

      function onSectionLoad(event) {
        const getSwiperItemIndex = sessionStorage.getItem("selectedSlideIndex");
        swiper.slideTo(getSwiperItemIndex);
      }

      document.addEventListener("shopify:block:select", onBlockSelect);
      document.addEventListener("shopify:block:deselect", onBlockSelect);
      document.addEventListener("shopify:section:load", onSectionLoad);
      document.addEventListener("shopify:section:select", onSectionLoad);
    }
  }
  return Slider;
})();
